import { graphql } from 'gatsby';

export const TextBlockSliceFragment = graphql`
    fragment PrismicTextBlockFragment on PRISMIC_PageBodyText_block {
        type
        primary {
            text_block_content
        }
    }
`;
